var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.996,
    height: 66.495,
    viewBox: "0 0 56.996 66.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52734",
    "data-name": "Path 52734",
    d: "M0,22.1H57V-44.4H0Z",
    transform: "translate(0 44.4)",
    fill: "#3db6fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50294",
    "data-name": "Group 50294",
    transform: "translate(0 44.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50293",
    "data-name": "Group 50293",
    transform: "translate(0 -44.4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50291",
    "data-name": "Group 50291",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52732",
    "data-name": "Path 52732",
    d: "M17.361,0h-47.5a4.756,4.756,0,0,0-4.751,4.749v57A4.756,4.756,0,0,0-30.135,66.5h47.5a4.753,4.753,0,0,0,4.749-4.749v-57A4.753,4.753,0,0,0,17.361,0M-.846,35.623A1.583,1.583,0,0,1,.737,37.206,1.583,1.583,0,0,1-.846,38.789a1.583,1.583,0,0,1-1.583-1.583A1.583,1.583,0,0,1-.846,35.623M-7.97,58.579H-22.22A1.584,1.584,0,0,1-23.8,57a1.584,1.584,0,0,1,1.583-1.583H-7.97A1.583,1.583,0,0,1-6.387,57,1.583,1.583,0,0,1-7.97,58.579m0-6.332H-22.22A1.584,1.584,0,0,1-23.8,50.664a1.585,1.585,0,0,1,1.583-1.584H-7.97a1.584,1.584,0,0,1,1.583,1.584A1.584,1.584,0,0,1-7.97,52.247m0-6.334h-19a1.583,1.583,0,0,1-1.583-1.583,1.583,1.583,0,0,1,1.583-1.583h19A1.583,1.583,0,0,1-6.387,44.33,1.583,1.583,0,0,1-7.97,45.913m0-6.332h-19A1.584,1.584,0,0,1-28.552,38a1.584,1.584,0,0,1,1.583-1.583h19A1.584,1.584,0,0,1-6.387,38,1.584,1.584,0,0,1-7.97,39.581m1.583-8.709H-28.552V8.707H-6.387ZM15.778,58.579h-19V41.163h19ZM2.32,37.206A1.583,1.583,0,1,1,3.9,38.789,1.583,1.583,0,0,1,2.32,37.206m4.751,0a1.583,1.583,0,1,1,1.583,1.583A1.583,1.583,0,0,1,7.07,37.206m4.749,0A1.583,1.583,0,1,1,13.4,38.789a1.583,1.583,0,0,1-1.583-1.583m3.958-10.292H-1.638V20.581H15.778Zm0-10.29H-1.638V10.29H15.778Z",
    transform: "translate(34.886)",
    fill: "#3db6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50292",
    "data-name": "Group 50292",
    transform: "translate(8.829 12.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52733",
    "data-name": "Path 52733",
    d: "M5.652,5.412a.848.848,0,0,1-.446.335H-10.731a.885.885,0,0,1-.587-1.105c.007-.027.018-.052.027-.078l.529-1.325A4.509,4.509,0,0,1-8,.632L-5.44-.214A.457.457,0,0,0-5.17-.8.464.464,0,0,0-5.314-1,5.805,5.805,0,0,1-7.279-5.474a5.02,5.02,0,0,1,4.508-5.4,5.02,5.02,0,0,1,4.508,5.4A5.8,5.8,0,0,1-.229-1,.456.456,0,0,0-.3-.357a.449.449,0,0,0,.2.142L2.456.632A4.509,4.509,0,0,1,5.22,3.239l.527,1.325a.88.88,0,0,1-.094.848Z",
    transform: "translate(11.357 10.876)",
    fill: "#3db6fb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.9345dfad35ee6b71bd08c56c502a5076.svg";
export { ForwardRef as ReactComponent };